export const ADD_QUIZ = "ADD_QUIZ";
export const SAVE_QUIZ = "SAVE_QUIZ";
export const ADD_QUESTION = "ADD_QUESTION";
export const ADD_ANSWER = "ADD_ANSWER";
export const SET_QUIZ = "SET_QUIZ";
export const QUIZ_DATABASE_ID = "QUIZ_DATABASE_ID";
export const OPEN_QUIZ = "OPEN_QUIZ";
export const IDS_QUESTIONS_INSERTED = "IDS_QUESTIONS_INSERTED";
export const SET_LOADING_QUIZ = "SET_LOADING_QUIZ";
export const QUIZ_ID = "QUIZ_ID";